
/**
 * @import internal modules
 */
import Router from "@apps-routes/index";

/**
 * @import external modules
 */
import * as React from "react";



/**
 * @function Component 
 * @param props 
 */
const Component: React.FunctionComponent<any> = (props: any): JSX.Element =>{

    return(

        <Router {...props}/>
    )
    
}


export default Component;
/**
 * @return Component
 * @version 1.0.0
 */


// WEBPACK FOOTER //
// ./src/root/routes/index.tsx